import React from 'react';
import ReactDOM from 'react-dom';
import { Route, Switch, BrowserRouter as Router } from 'react-router-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import WallboardPCS from './Wallboards/WallboardPCS';
import WallboardPHD from './Wallboards/WallboardPHD';
import WallboardICT from './Wallboards/WallboardICT';

ReactDOM.render(
  <Router>
        <Switch>
            <Route exact path="/" component={App} />
            <Route exact path="/PCS" component={WallboardPCS} />
            <Route exact path="/PHD" component={WallboardPHD} />
            <Route exact path="/ICT" component={WallboardICT} />
        </Switch>
  </Router>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
